import { getTimeInputFromTimestamp } from '../../../utilities/get-time-input-from-timestamp';
import { LINKS_EMPTY_VALUES } from '../constants';
import { unflattenFieldArray } from './transform-field-array';

export const transformLinkDataForForm = (existingLink) => {
  return existingLink
    ? {
        ...existingLink,
        startTime: getTimeInputFromTimestamp(existingLink.startDate),
        tags: unflattenFieldArray(existingLink.tags),
        filters: unflattenFieldArray(existingLink.filters),
      }
    : LINKS_EMPTY_VALUES;
};
